import React, {useState} from 'react';

import {Dropdown, Icon, IconInput, MenuListItem, Text} from '@albert-io/atomic';

import {BadgesAchieved} from './BadgesAchieved';
import {StudentSkillPathList} from './StudentSkillPathList';
import classNames from 'classnames';

export interface StudentSkillPathProps {}

type FilterOption = 'All' | 'To Do';
const FILTER_OPTIONS: FilterOption[] = ['All', 'To Do'];

export interface StudentSkillPathDropdownProps {
  selectedFilter: FilterOption;
  setSelectedFilter: (option: FilterOption) => void;
}

export function StudentSkillPathDropdown({
  selectedFilter,
  setSelectedFilter
}: StudentSkillPathDropdownProps) {
  return (
    <Dropdown
      contentClassName='p-x1!'
      position='bottom-start'
      trigger={
        <IconInput
          type='button'
          iconRight='caret-down'
          value={selectedFilter}
          className='py-x1-quarter!! min-w-[92px] cursor-pointer px-x2! text-left'
        />
      }
      closeOnItemClicked
      positionFixed
    >
      {FILTER_OPTIONS.map((option) => (
        <MenuListItem
          key={option}
          as='li'
          className={classNames(
            'justify-start border-0! px-x1-half! py-x1! hover:background-info-subtle!',
            {
              'background-info-subtle!': selectedFilter === option
            }
          )}
          onClick={() => setSelectedFilter(option)}
          aria-selected={selectedFilter === option}
        >
          <Text
            className='flex w-full items-center justify-between'
            size={'m'}
            color={selectedFilter === option ? 'info' : 'primary'}
          >
            {option}
            {selectedFilter === option && <Icon icon='check' color='info' />}
          </Text>
        </MenuListItem>
      ))}
    </Dropdown>
  );
}

export function StudentSkillPath() {
  const [selectedFilter, setSelectedFilter] = useState<FilterOption>('To Do');

  return (
    <div className='student-skill-path flex w-full flex-col'>
      <div className='flex items-center justify-between border-t border-t-border-subtle px-x4 py-x3'>
        <StudentSkillPathDropdown
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
        <BadgesAchieved />
      </div>
      <StudentSkillPathList filter={selectedFilter} />
    </div>
  );
}
